module.exports = __webpack_public_path__ + "img/agma2015-2-B15_fig04_agma-classification-individual-vals.0ae82e55.png";